// extracted by mini-css-extract-plugin
export default {"container":"Vp-z","ratingLayout":"Wp-z","ratingLabel":"Xp-z","nonInteractiveRatingLabel":"Yp-z"};